import { useEffect } from "react";
import Header from "@/components/Header";
import SessionWalkthroughSection from "@/components/SessionWalkthroughSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import Footer from "@/components/Footer";

const FeaturesPage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute("content");
    document.title = "How MyEnglish Lesson Works | MyEnglish Lesson.ca";
    description?.setAttribute("content", "See how MyEnglish Lesson combines real-life scenarios, live online practice, and practical phrases for conversations in Canada.");
    return () => { document.title = previousTitle; if (description && previousDescription) description.setAttribute("content", previousDescription); };
  }, []);

  const goToBookings = () => { window.location.href = "/#booking-section"; };

  return <div className="site-shell" id="features-page-top"><Header homePrefix="/" onBook={goToBookings} /><main id="main-content"><SessionWalkthroughSection /><TestimonialsSection /></main><Footer homePrefix="/" /></div>;
};

export default FeaturesPage;
